"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldRenderTextField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var validators_1 = require("utils/form/validators");
var TextField = (0, material_1.styled)(TextField_1.default)(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    return ({
        '.MuiInputBase-input': {
            color: theme.palette.riverstone,
        },
        '.MuiOutlinedInput-root': __assign({ backgroundColor: theme.palette.common.white, '> .MuiOutlinedInput-notchedOutline': {
                borderColor: (props === null || props === void 0 ? void 0 : props.color) && ((_b = theme.palette[props.color || 'primary']) === null || _b === void 0 ? void 0 : _b.light),
            }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderWidth: 1,
            }, 
            // '& input:focus-visible + .MuiOutlinedInput-notchedOutline': theme.focusVisibleStyles, // this has the activeElement on pressing tab key
            // '&:focus-visible + .MuiOutlinedInput-notchedOutline': theme.focusVisibleStyles,
            '&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': { borderColor: (_c = theme.palette[props.color || 'primary']) === null || _c === void 0 ? void 0 : _c.main }, '&.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.error.main }, '&:hover': {
                ':not(.Mui-disabled):not(.Mui-error) > .MuiOutlinedInput-notchedOutline': {
                    borderColor: (_d = theme.palette[props.color || 'primary']) === null || _d === void 0 ? void 0 : _d.main,
                },
            }, '&.MuiInputAdornment-sizeSmall': { marginLeft: theme.spacing(0.5) }, '&.MuiInputBase-adornedEnd': {
                paddingRight: theme.spacing(1),
                '.MuiInputAdornment-positionEnd': { marginLeft: theme.spacing(0.5) },
                '.MuiInputAdornment-positionStart': { marginRight: theme.spacing(0.5) },
            } }, props.label === undefined && {
            legend: { width: 'unset' },
            '&.MuiInputBase-sizeSmall': {
                input: { padding: theme.spacing(0.5625, 1) },
            },
        }),
        '.MuiFilledInput-root': {
            backgroundColor: (_e = theme.palette) === null || _e === void 0 ? void 0 : _e.grey[100],
            '&:hover': {
                backgroundColor: (_g = (_f = theme.palette) === null || _f === void 0 ? void 0 : _f.neutral) === null || _g === void 0 ? void 0 : _g.light,
                ':not(.Mui-disabled):before': { borderColor: (_h = theme.palette[props.color || 'primary']) === null || _h === void 0 ? void 0 : _h.dark },
            },
        },
        '.MuiInput-underline': {
            '&:hover': {
                ':not(.Mui-disabled):before': { borderColor: (_j = theme.palette[props.color || 'primary']) === null || _j === void 0 ? void 0 : _j.dark },
            },
        },
        '.MuiFormHelperText-root': {
            margin: 0,
            marginTop: theme.spacing(0.25),
            paddingLeft: theme.spacing(1.5),
            textAlign: 'left',
            '&.MuiFormHelperText-sizeSmall': {
                fontSize: 12,
                lineHeight: '14px',
            },
        },
    });
});
exports.default = TextField;
var FieldRenderTextField = function (_a) {
    var // FieldText??
    _b = _a.input, name = _b.name, onChange = _b.onChange, value = _b.value, restFormInputProps = __rest(_b, ["name", "onChange", "value"]), meta = _a.meta, helperText = _a.helperText, rest = __rest(_a, ["input", "meta", "helperText"]);
    var error = (0, validators_1.getTextFieldErrorToShow)(meta);
    var subText = error !== null && error !== void 0 ? error : helperText;
    return ((0, jsx_runtime_1.jsx)(TextField, __assign({ variant: "outlined", color: "primary" }, rest, { name: name, value: value, onChange: onChange, error: !!error, helperText: subText && (subText.startsWith('MD:') ? (0, jsx_runtime_1.jsx)(markdown_to_jsx_1.default, { children: subText.replace(/^MD:/, '') }) : subText), inputProps: restFormInputProps })));
};
exports.FieldRenderTextField = FieldRenderTextField;
